var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"isRecording":_vm.isRecording,"recordingTime":_vm.recordingTime,"startRecording":_vm.startRecording,"stopRecording":_vm.stopRecording,"deleteRecording":_vm.deleteRecording})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }